import useApiRequest from "@/lib/hooks/use-request";
import { SalesRankListResponseDto } from "@/lib/interfaces/sales-ranks";
import { Paginated, Pagination } from "@/lib/interfaces/utils";
import DataFetchParent from "@/ui-components/ui/data-fetch";
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import SalesRanksDataTable from "./sales-ranks-data-table";

const SalesRanksFetcher = ({
  searchQuery,
  setReload,
  reload,
}: {
  searchQuery: string;
  setReload: Dispatch<SetStateAction<boolean>>;
  reload: boolean;
}) => {
  const [items, setItems] = useState<SalesRankListResponseDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { apiRequest } = useApiRequest();
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: searchQuery.split("page=")[1] ? parseInt(searchQuery.split("page=")[1].split("&")[0]) - 1 : 0,
    pageSize: 10,
  });

  const [pageCount, setPageCount] = useState<number>(0);

  const getItemsPaginated = useCallback(async () => {
    setIsLoading(true);
    let url = `settings/sales-ranks?limit=${pagination.pageSize}&page=${pagination.pageIndex + 1}`;
    const response = await apiRequest<Paginated<SalesRankListResponseDto>>(url, "GET");
    setIsLoading(false);
    if (response.data) {
      setItems(response.data.docs);
      setPageCount(response.data.pageCount);
    }
  }, [apiRequest, pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    getItemsPaginated();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, getItemsPaginated, reload]);

  return (
    <DataFetchParent
      data={items}
      isLoading={isLoading}
      renderElement={(response: SalesRankListResponseDto[]) => (
        <div className="w-full p-4">
          <SalesRanksDataTable
            data={response}
            setReload={setReload}
            setPagination={setPagination}
            pageCount={pageCount}
            pagination={pagination}
            isLoading={isLoading}
          />
        </div>
      )}
    />
  );
};

export default SalesRanksFetcher;
